// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CPWw3","title":"styles_title__onJd9"};